import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { COLORS2, REDESIGN_COLORS, REDESIGN_FONTS } from '../../constants';

// Status values come from adminService.STATUS_CASE on the backend.
const TONES = {
    active: { background: REDESIGN_COLORS.mist, color: REDESIGN_COLORS.link },
    trial: { background: REDESIGN_COLORS.amberSurface, color: '#8A5A00' },
    canceled: { background: '#FDECE4', color: COLORS2.secondaryD2 },
    expired: { background: REDESIGN_COLORS.sand, color: REDESIGN_COLORS.muted },
    free: { background: REDESIGN_COLORS.toggleTrack, color: REDESIGN_COLORS.body },
};

const useStyles = makeStyles(() => ({
    chip: {
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: '999px',
        fontSize: '0.74rem',
        fontWeight: REDESIGN_FONTS.weightHeading,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        lineHeight: 1.5,
    },
}));

export const STATUS_LABELS = {
    active: 'Active',
    trial: 'Trial',
    canceled: 'Canceled',
    expired: 'Expired',
    free: 'Free',
};

const StatusChip = ({ status }) => {
    const classes = useStyles();
    if (!status) {
        return <span>—</span>;
    }
    const tone = TONES[status] || TONES.free;
    return (
        <span className={classes.chip} style={tone}>
            {STATUS_LABELS[status] || status}
        </span>
    );
};

export default StatusChip;
